/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Nav_Wpm_Exceeds_HintInputs */



/**
* | output |
* | --- |
* | "Extend duration of Event, or reduce text content." |
*
* @param {Error_Nav_Wpm_Exceeds_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_nav_wpm_exceeds_hint = /** @type {((inputs?: Error_Nav_Wpm_Exceeds_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Nav_Wpm_Exceeds_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Allongez la duree de l'evenement ou reduisez le texte.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Verlängern Sie die Dauer des Ereignisses oder reduzieren Sie den Textinhalt.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Estendi la durata dell'evento o riduci il contenuto del testo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Увеличьте продолжительность мероприятия или сократите текстовое содержимое.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ampliar la duración del evento o reducir el contenido del texto.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("延长活动持续时间，或减少文本内容。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントの期間を延長するか、テキストコンテンツを減らします。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("इवेंट की अवधि बढ़ाएं या टेक्स्ट की मात्रा कम करें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Prolongue a duração do evento ou reduza o conteúdo do texto.")
	return /** @type {LocalizedString} */ ("Extend duration of Event, or reduce text content.")
});